var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstantPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0008 18.2624C11.5421 18.2624 8.73828 15.4586 8.73828 11.9999C8.73828 8.54115 11.5421 5.7373 15.0008 5.7373C18.4595 5.7373 21.2634 8.54115 21.2634 11.9999C21.2634 15.4586 18.4595 18.2624 15.0008 18.2624ZM15.0008 19.7624C10.7137 19.7624 7.23828 16.287 7.23828 11.9999C7.23828 7.71272 10.7137 4.2373 15.0008 4.2373C19.288 4.2373 22.7634 7.71272 22.7634 11.9999C22.7634 16.287 19.288 19.7624 15.0008 19.7624Z",
    fill: "#54FF99"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25 5C6.25 4.58579 6.58579 4.25 7 4.25H15C15.4142 4.25 15.75 4.58579 15.75 5C15.75 5.41421 15.4142 5.75 15 5.75H7C6.58579 5.75 6.25 5.41421 6.25 5Z",
    fill: "#54FF99"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.68944 11.25H7.67835C8.09257 11.25 8.42836 11.5858 8.42836 12C8.42836 12.4142 8.09257 12.75 7.67836 12.75H3.68945C3.27523 12.75 2.93945 12.4142 2.93945 12C2.93944 11.5858 3.27523 11.25 3.68944 11.25Z",
    fill: "#54FF99"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 19C1.25 18.5858 1.58579 18.25 2 18.25H15C15.4142 18.25 15.75 18.5858 15.75 19C15.75 19.4142 15.4142 19.75 15 19.75H2C1.58579 19.75 1.25 19.4142 1.25 19Z",
    fill: "#54FF99"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7172 9.17188L16.8951 10.5254C16.484 10.2346 16.0028 10.0241 15.5516 9.91379V11.1069C17.1357 11.4879 17.9478 12.0292 17.9478 13.2725V13.2925C17.9478 14.5257 16.9953 15.2676 15.5817 15.3979V16.3805H14.539V15.3879C13.5364 15.2776 12.594 14.9367 11.832 14.3853L12.7344 13.0519C13.386 13.493 13.9675 13.7737 14.5992 13.884V12.6709C12.995 12.2999 12.1629 11.7485 12.1629 10.4953V10.4752C12.1629 9.30222 13.0251 8.49012 14.5591 8.37984V7.79834H15.6017V8.39989C16.4339 8.51018 17.1056 8.77085 17.7172 9.17188ZM16.2133 13.4228V13.4028C16.2133 13.1321 16.0629 12.9817 15.5416 12.8313V13.9342C15.9928 13.8941 16.2133 13.7236 16.2133 13.4228ZM13.9274 10.3249V10.3449C13.9274 10.6156 14.0578 10.766 14.6092 10.9164V9.83359C14.1179 9.86366 13.9274 10.0542 13.9274 10.3249Z",
    fill: "#54FF99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstantPayment);
export default __webpack_public_path__ + "static/media/instant-payment.25083dd775c92fca9b70e2425bd10a72.svg";
export { ForwardRef as ReactComponent };